/**
 * 낭만월운 표지 일러스트 — 양력 월(1~12) → 이미지 매핑.
 * 디자인에 일러스트 추가되는 대로 키만 채우면 됨.
 */
import imgSnakePng from '@manseImages/img_mf-cover_snake@2x.png';
import imgHorsePng from '@manseImages/img_mf-cover_horse@2x.png';
import imgSheepPng from '@manseImages/img_mf-cover_sheep@2x.png';
import imgMonkeyPng from '@manseImages/img_mf-cover_monkey@2x.png';
import imgSnakeSvg from '@manseImages/img_mf-cover_snake.svg?url';
import imgHorseSvg from '@manseImages/img_mf-cover_horse.svg?url';
import imgSheepSvg from '@manseImages/img_mf-cover_sheep.svg?url';
import imgMonkeySvg from '@manseImages/img_mf-cover_monkey.svg?url';
import imgFallback from '@manseImages/img_month-2_fortune.png';

const ILLUSTRATIONS_BY_MONTH = {
  5: imgSnakePng,
  6: imgHorsePng,
  7: imgSheepPng,
  8: imgMonkeyPng,
};

const ILLUSTRATIONS_BY_MONTH_PC = {
  5: imgSnakeSvg,
  6: imgHorseSvg,
  7: imgSheepSvg,
  8: imgMonkeySvg,
};

export const getCoverIllustration = (month, variant = 'mobile') => {
  const map = variant === 'pc' ? ILLUSTRATIONS_BY_MONTH_PC : ILLUSTRATIONS_BY_MONTH;

  return map[month] || imgFallback;
};
